<template>
    <div>
        <div class="SearchHead">
            <el-button v-throttle size="small" type="primary" icon="el-icon-back" @click="goBack"></el-button>
            <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="GetData">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="GetData"></i>
            </el-input>
            <!-- <el-button v-throttle type="text" @click="TypeBlon = true">切换</el-button> -->
        </div>
        <div class="ListHead">
            <nut-infiniteloading
                @loadmore="PageChange" 
                :is-show-mod="true" 
                :is-loading="loading" 
            >
            <nut-cell v-for="item in Data" :key="item.id" :show-icon="true" @click-cell="GoPage(item)">
                <span slot="title">{{item.record_name}}</span>
                <span slot="sub-title">申请人：{{item.user_name}}</span>
                <span slot="desc">查看</span>
            </nut-cell>
            </nut-infiniteloading>
            <div v-if="Data.length==0" class="NoData">当前无数据</div>
        </div>
        <nut-popup v-model="TypeBlon" position="bottom">
            <nut-cell :show-icon="true" @click-cell="ResetData('ZL')">
                <span slot="title">资料评审</span>
                <span slot="desc">选择</span>
            </nut-cell>
            <nut-cell :show-icon="true" @click-cell="ResetData('XC')">
                <span slot="title">现场评审</span>
                <span slot="desc">选择</span>
            </nut-cell>
        </nut-popup>
        <el-dialog title="申请须知" top="3vh" :visible.sync="ShenQingBlon" width="95%" :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <el-image v-if="ShenQingData.kv_url" :src="$Tools.ServeUrl()+ShenQingData.kv_url" fit="contain"></el-image>
            <div class="SqCont" v-html="ShenQingData.ps_xz" v-if="ShenQingData.ps_xz"></div>
            <div slot="footer">
                <div class="footer">
                    <el-button v-throttle class="BgColor" size="small" type="primary" @click="ShenQingBlon=false">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                ApiType:"",
                Type:"XC",
                TypeBlon:false,
                ShenQingBlon:true,
                ShenQingData:"",
                Page:1,
                PageSize:10,
            };
        },
        mounted() {
            this.ApiType = sessionStorage.getItem('ThisSysTem');
            this.getSqData();
        },
        methods: {
            GetData(){
                this.loading = true;
                var url = this.Type=='ZL'?'/api/expert_portal/online/list':'/api/expert_portal/final/list';
                this.$get(url,{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        if(this.Page==1&&res.data.list.length==0){
                            this.Data = [];
                            this.$toast.text('当前无数据');
                        }
                        if(this.Page==1&&res.data.list.length>0){
                            this.Data = res.data.list;
                        }
                        if(this.Page>1&&res.data.list.length>0){
                            this.Data.push(res.data.list);
                        }
                    }
                })
            },
            getSqData() {
                this.$get('/api/expert_portal/count').then(res => {
                    if (res) {
                        this.ShenQingData = res.data;
                        this.GetData();
                    }
                })
            },
            ResetData(t){
                this.Type = t;
                this.Page = 1;
                this.Data = [];
                this.GetData();
                this.TypeBlon = false;
            },   
            GoPage(i){
                this.$router.push({path: "/MobileExpert/"+i.id+"/"+this.Type});
            },
            goBack(){
                this.$router.go(-1);
            },
            PageChange(){
                this.Page +=1;
                this.GetData();
            },
        }
    }
</script>

<style scoped>
    .SearchHead{
        margin: 10px;
    }
    .NoData{
        text-align: center;
        padding: 10px 0;
        color: #999;
        font-size: 14px;
    }
    .SqCont{
        max-height: 60vh;
        overflow-y: auto;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 20px;
    }
</style>